<template>
  <div>
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
    <v-card class="mb-5">
      <v-card-text>
        <v-container grid-list-xl fluid>
          <v-layout wrap>
            <v-flex xs12 sm3>
              <v-autocomplete
                v-model="transaction.account"
                :loading="accountLoading"
                :items="accounts"
                label="Account"
                :rules="[v => !!v || 'Account is required']"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm3>
              <v-autocomplete
                v-model="transaction.category"
                :loading="categoryLoading"
                :items="categories"
                label="Category"
                :rules="[v => !!v || 'Category is required']"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm3>
              <v-autocomplete
                v-model="transaction.tags"
                :loading="tagLoading"
                :items="tags"
                multiple
                chips
                clearable
                label="Tags"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm3>
              <v-switch v-model="useNotes" class="ma-4" label="Use Org Notes"></v-switch>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-title>Create transaction</v-card-title>
      <v-card-text>
        <v-container grid-list-xl fluid>
          <v-layout wrap>

            <v-flex xs6 sm2>
              <v-menu
                ref="datemenu"
                v-model="datemenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateFormatted"
                    label="Date"
                    ref="datemenuinp"
                    :hint = "dateHint" persistent-hint
                    @blur="transaction.date = parseDate(dateFormatted); datemenu=false;"
                    v-on="on"
                    @keyup.shift.enter="validateAndSave"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="transaction.date" no-title @input="datemenu = false">
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm6>
              <v-text-field
                v-if="!useNotes"
                v-model="transaction.narration"
                label="Narration"
                @keyup.shift.enter="validateAndSave"
                ></v-text-field>
              <v-text-field
                v-else

                v-model="transaction.org_notes"
                label="Org Notes"
                @keyup.shift.enter="validateAndSave"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 sm3>
              <v-text-field 
                ref="amount"
                v-model="transaction.amount"
                type="number"
                :rules="[v => !!v || 'Required valid amount']" label="Amount"
                :hint = "amountHint" persistent-hint
                @keyup.shift.enter="validateAndSave"
                required></v-text-field>
            </v-flex>


          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <loading-state text="" :state="state"></loading-state>
        <!-- <v-btn color="blue darken-1" text v-show="!state.isLoading()" @click="$emit('input', false)">Close</v-btn> -->
        <v-btn :disabled="(!valid) || state.isLoading()" color="success" class="mr-4" @click="validateAndSave"
        >
        <span v-if="transaction.key">Save</span><span v-else>Create</span>
        </v-btn>
      </v-card-actions>
    </v-card>
    </v-form>
  </div>

</template>
<script>
import moment from 'moment'
import Utils from "@/utils"
import { DataState } from "@/state"
import { Account } from "@/models/account"
import { Category } from "@/models/category"
import { Tag } from "@/models/tag"
import { Transaction } from "@/models/transaction"
export default {
  props: {
    transaction: {
      default: ()=>{return Transaction.newEmpty()},
      type: Object
    }
  },
  data: () => ({
    dateFormat: 'YYYY-M-D',
    timeFormat: 'HH:mm',
    dateFormatted: '',
    state: DataState.newNotInit(),
    accountLoading: false,
    accounts: [],
    categoryLoading: false,
    categories: [],
    tagLoading: false,
    tags: [],
    datemenu: false,
    valid: true,
    lazy: true,
    useNotes: false,
  }),
  watch: {
    'transaction.date' (val) {
      this.dateFormatted = this.formatDate(this.transaction.date)
    }
  },
  mounted () {

    this.onLoaded()
  },
  computed: {
    amountHint () {
      if (!this.transaction.account) {
        return ''
      }

      let res =  Utils.price(this.transaction.amount, this.transaction.account.currency)
      return res
    },

    dateHint () {
      if (!this.transaction.date) {return ''}
      return moment(this.transaction.date, this.dateFormat).format('ddd, YYYY-MMM-D')
    },

    timeHint () {
      if (!this.transaction.time) {return ''}
      return moment(this.transaction.time, this.timeFormat).format('hh:mm A')
    },

    computedDateFormatted () {
      return this.formatDate(this.transaction.date)
    }
  },
  methods: {
    onLoaded () {
      if(this.transaction.date) {
        this.dateFormatted = this.formatDate(this.transaction.date)
      }

      this.accountLoading = true
      Account.list().then((response) => {
        this.accounts = response.map((r) => {
          return { text: r.name, value: r }
        })
        this.accountLoading = false
        this.categoryLoading = true
        return Category.list()
      }).then((response) => {
        this.categories = response.map((r) => {
          return { text: r.name, value: r }
        })
        this.categoryLoading = false
        this.tagLoading = true
        return Tag.list()
      }).then((response) => {
        this.tags = response.map((r) => {
          return { text: r.name, value: r.name }
        })
        this.tagLoading = false
      }).catch((error) => {
        console.log('Err', error)
      })
    },

    validate () {
      if (this.$refs.form.validate()) {
        this.saveTransaction()
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    formatDate (date) {
      return moment(date, this.dateFormat).format(this.dateFormat)
    },

    parseDate (date) {
      let newDate = date
      if (!newDate) {
        newDate = this.transaction.date
      }
      return moment(newDate, this.dateFormat).format(this.dateFormat)
    },
    validateAndSave () {
      if (this.$refs.form.validate()) {
        this.saveTransaction()
      }
    },
    saveTransaction () {
      this.transaction.time = '00:00'
      this.transaction.currency = this.transaction.account.currency
      this.valid = false
      this.state.changeToLoading()
      this.transaction.create().then((response) => {

        const old_date = this.transaction.date
        // this.$refs.form.reset()

        this.valid = false
        this.transaction.key = null
        // this.transaction.date = old_date
        this.transaction.narration = ''
        this.transaction.org_notes = ''
        this.transaction.note = ''
        this.transaction.amount = 0

        this.state.changeToLoaded()
        this.$emit('created', response)
        this.$refs.datemenuinp.focus()
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },
  },
}
</script>